import { colors } from '@/theme/foundations/colors';

// Chakra's own base tokens, which colors.js does not redeclare.
const CHAKRA_BASE = { white: '#FFFFFF', black: '#000000' } as const;

type FlatColorToken = {
  [K in keyof typeof colors]: (typeof colors)[K] extends string ? K : never;
}[keyof typeof colors];

export type ColorToken = (FlatColorToken | keyof typeof CHAKRA_BASE) & string;

const PALETTE: Record<string, unknown> = { ...CHAKRA_BASE, ...colors };

/**
 * A theme-aware colour for places Chakra's style props don't reach: inline
 * `style`, `@kula-ai/icons-core` icons (bare `<svg>`), react-select style
 * functions.
 *
 * `colors['secondary-700']` is a hex literal and stays light in dark mode;
 * `colorVar('secondary-700')` reads the variable Chakra declares for that
 * token (`--kula-colors-secondary-700`, re-declared by the dark palette) and
 * falls back to the same hex wherever no ChakraProvider has mounted.
 */
export const colorVar = (token: ColorToken): string =>
  `var(--kula-colors-${token}, ${PALETTE[token] as string})`;
